var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button is-primary is-fullwidth"},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fal fa-car-building"})]),_c('span',{staticClass:"has-text-weight-semibold"},[_vm._v(" This vehicle is in your stock ")])])
}]

export { render, staticRenderFns }